/*
 * @Author: fanyang 1050549505@qq.com
 * @Date: 2022-07-22 10:28:35
 * @LastEditors: fanyang 1050549505@qq.com
 * @LastEditTime: 2022-07-22 11:23:16
 * @FilePath: /yhkh/src/utils/analysisUtils.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export function getMemberTag(type) {
    let tag = ''
    switch (type) {
        case '2':
            tag = '特困补贴'
            break;
        case '3':
            tag = '家庭床位'
            break;
        case '4':
            tag = '居家上门'
            break;
        case '5':
            tag = '计生特扶'
            break;
        case '6':
            tag = '区级拓面'
            break;
        case '7':
            tag = '外转本'
            break;
        case '8': 
            tag = '放弃'
            break;
        case '9':
            tag = '转区'
            break;
        case '10': 
            tag = '离世'
            break;
        case '-1': 
            tag = '其他'
            break;
        default:
            break;
    }
    return tag
}

export function getDisablityType(type){
    let diasble = ''
    switch (type) {
        case '1':
            diasble = '健康'
            break;
        case '2':
            diasble = '轻度失能'
            break;   
        case '3':
            diasble = '中度失能'
            break;
        case '4':
            diasble = '重度失能'
            break;
        case '5':
            diasble = '其他'
            break;
        default:
            break;
    }
    return diasble
}

export function getLiveStatusType(type){
    let live = ''
    switch (type) {
        case '1':
            live = '亲属共住'
            break;
        case '2':
            live = '空巢'
            break;   
        case '3':
            live = '独居'
            break;
        case '4':
            live = '孤寡'
            break;
        case '5':
            live = '机构'
            break;
        case '6':
            live = '其他'
            break;
        default:
            break;
    }
    return live
}